'use client';
/** @jsxImportSource @emotion/react */

import type { CardProps } from '@mui/material/Card';

import MuiCard from '@mui/material/Card';

export type { CardProps };

export const Card = MuiCard;
